import { render, staticRenderFns } from "./NoBrandsAnimatedIcon.vue?vue&type=template&id=69d63b0d&scoped=true"
import script from "./NoBrandsAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./NoBrandsAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d63b0d",
  null
  
)

export default component.exports